// Used as the id for the car filter html element.
export const CAR_FILTER_ID = "tor-car-filter";

export const CAR_FILTER_WIKI_URL = "https://dxpwiki.toyota.eu/dxpdocumentation/componentsoverview/car-filter";
